import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, HostListener } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { BehaviorSubject, Subscription } from 'rxjs';
import { VisualiserMessages } from 'src/app/modules/shared/models/component-messages/visualiser-messages';
import { StatusHelper } from '../../../shared/helpers/StatusHelper';
import { StatusState } from '../../../shared/models/enum/statusState';
import { LogService } from '../../../shared/services/log.service';
import { AvisService } from '../../services/avis-service';
import { Synthesis } from './model/synthesis';

@Component({
	selector: 'app-synthese',
	templateUrl: './synthese.component.html',
	styleUrls: ['./synthese.component.scss'],
})
export class SyntheseComponent implements OnInit, OnDestroy {

	private LOG: LogService = new LogService(SyntheseComponent);
	@Input() referenceAvis: string;
	@Input() currentJson: any = new BehaviorSubject(null);
	@Output() hasUnsavedChanges = new EventEmitter<boolean>(true);

	public visualiserMessages = new VisualiserMessages();
	public synthesis: Synthesis = new Synthesis();
	public statusHelper = StatusHelper;
	private _statusState = StatusState;
	private subscriptions: Subscription = new Subscription();
	public syntheseForm: FormGroup;
	public innerWidth: any;

	constructor(private _avisService: AvisService, private formBuilder: FormBuilder, private router: Router) { }

	public ngOnInit() {
		this.innerWidth = window.innerWidth;
		this.hasUnsavedChanges.emit(false);
		this.avisService.shouldUpdateSynthesis = false;
		this.syntheseForm = this.formBuilder.group({});
		this.getSynthese();
	}

	public getSynthese() {
		this.subscriptions.add(
			this.avisService.getSynthese(this.referenceAvis).subscribe((data) => {
				this.synthesis = data;
				this.avisService.synthesis = this.synthesis;
				if (this.synthesis) {
					this.synthesis.supportDiffusionList?.forEach((support, i) => {
						if (support.code !== '') {
							support.listeDiffusionList?.forEach((liste) => {
								const isDisabled: boolean =
									liste.status?.toString() !== this.statusHelper.getStatusClass(this.statusState.ENVOYE).toUpperCase() &&
									liste.status?.toString() !== this.statusHelper.getStatusClass(this.statusState.EN_ATTENTE).toUpperCase();
								this.syntheseForm.addControl(
									'status-' + i,
									new FormControl({ value: liste.status, disabled: isDisabled })
								);
							});
						}
					});
				}
			})
		);
	}

	public updateSynthese() {
		this.avisService.shouldUpdateSynthesis$.subscribe((value) => {
			if (value) {
				this.synthesis.supportDiffusionList?.forEach((support, i) => {
					if (support.code !== '') {
						support.listeDiffusionList?.forEach((liste) => {
							liste.status = this.syntheseForm.get('status-' + i).value;
						});
					}
				});
				this.avisService.updateSynthese(this.synthesis).subscribe();
			}
			this.hasUnsavedChanges.emit(false);
		});
		this.router.navigate(['/avisdepublicite/listerAvisPub/']);
		this.avisService.shouldUpdateSynthesis = true;
	}

	public cancelSubmit() {
		this.subscriptions.unsubscribe();
		this.hasUnsavedChanges.emit(false);
		this.avisService.shouldUpdateSynthesis = false;
		this.synthesis.supportDiffusionList?.forEach((support, i) => {
			if (support.code !== '') {
				support.listeDiffusionList?.forEach((liste) => {
					this.syntheseForm.get('status-' + i).setValue(liste.status);
				});
			}
		});
	}

	public selectStatus() {
		this.hasUnsavedChanges.emit(true);
	}

	public get statusState() {
		return this._statusState;
	}

	public get avisService() {
		return this._avisService;
	}

	public ngOnDestroy() {
		this.subscriptions.unsubscribe();
	}

	@HostListener('window:resize', ['$event'])
	onResize(event) {
		this.innerWidth = window.innerWidth;
	}
}
